// eslint-disable-next-line import/prefer-default-export
export function mapFromApi(tax = {}) {
  return {
    tva: tax.tva,
    rpd: tax.rpd,
    rpdUnit: tax.rpd_unit,
  }
}
